import * as t from 'io-ts';

import { TMethod } from '../src/method';

import { City } from './w4d-city-types';

type Params = {
  get: TMethod;
  apiHost: string;
};

const w4dCitiesRemoteAPI = ({ apiHost, get }: Params) => ({
  readCities: {
    path: `${apiHost}/v6/cities`,
    method: get,
    response: t.type({
      cities: t.record(t.string, City),
    }),
  },
});

export { w4dCitiesRemoteAPI };
